export default __webpack_public_path__ + "static/media/map_slide.fa273bdd.png";